export class HostUtils {
  private constructor() {}

  public static isBrowserHosted(): boolean {
    return window.frs_host === undefined;
  }
}